import { SegmentFilters, } from "@domains/entities/interfaces/Reports/LedgerReport/ILedgerReportDetail";
import filter from "@domains/utils/filter";
export class LedgerReportCommonUseCase {
    constructor(filterUsecase) {
        this.filterUsecase = filterUsecase;
    }
    async getModifiedData(ledgerDetails, combinedState) {
        try {
            let filterData = this.filterUsecase.getFilteredData(ledgerDetails, combinedState.filterUiState);
            return filterData;
        }
        catch (error) {
            return Object.assign({}, ledgerDetails);
        }
    }
}
export class FilterUseCase {
    constructor() {
        // Filters used for ledger exch , voucher
        this.exchangeValues = {
            NSE: "NSE",
            BSE: "BSE",
            NSEF: "NSEF",
            BSEF: "BSEF",
            NSEC: "NSEC",
            BSEC: "BSEC",
        };
        this.voucherValues = {
            RECEIPT: "RECEIPT",
            PAYMENT: "PAYMENT",
            BILLS: "BILL",
            OPBAL: "OPBAL",
            JV: "JV",
        };
    }
    getFilteredData(ledgerData, { simpleFilter, assetFilter, productAssetFilter }) {
        let FilteredData = ledgerData.ledgerDetails;
        let VoucherFilterState = {
            FilterApplied: false,
            FilterState: [{ key: "voucherType", value: [] }],
        };
        let ExchangeFilterState = {
            FilterApplied: false,
            FilterState: [{ key: "exchange", value: [] }],
        };
        VoucherFilterState = this.detectSelectedFilter(simpleFilter, "voucherType");
        ExchangeFilterState = this.detectSelectedFilter(assetFilter, "exchange");
        FilteredData = this.handleSegmentFilter(ledgerData.ledgerDetails, productAssetFilter);
        if (ExchangeFilterState === null || ExchangeFilterState === void 0 ? void 0 : ExchangeFilterState.FilterApplied) {
            sessionStorage.setItem("simpleFilter", JSON.stringify(ExchangeFilterState.FilterState));
            FilteredData = filter(FilteredData, ExchangeFilterState.FilterState);
        }
        if (VoucherFilterState === null || VoucherFilterState === void 0 ? void 0 : VoucherFilterState.FilterApplied) {
            sessionStorage.setItem("assetFilter", JSON.stringify(VoucherFilterState.FilterState));
            FilteredData = filter(FilteredData, VoucherFilterState.FilterState);
        }
        return Object.assign(Object.assign({}, ledgerData), { ledgerDetails: FilteredData });
    }
    handleSegmentFilter(ledgerDetails, prodAssetFilter) {
        let filterState = {
            FilterApplied: false,
            FilterState: [],
        };
        let selectedFilter = prodAssetFilter.filters.find((filter) => filter.selected == true);
        if (selectedFilter) {
            switch (selectedFilter.key) {
                case SegmentFilters.CASH:
                    filterState.FilterState = [
                        {
                            key: "exchange",
                            value: [this.exchangeValues.NSE, this.exchangeValues.BSE],
                        },
                    ];
                    let tempCash = filter(ledgerDetails, filterState.FilterState);
                    filterState.FilterState = [
                        {
                            key: "voucherType",
                            value: [
                                this.voucherValues.BILLS,
                                this.voucherValues.JV,
                                this.voucherValues.PAYMENT,
                                this.voucherValues.RECEIPT,
                            ],
                        },
                    ];
                    return filter(tempCash, filterState.FilterState);
                case SegmentFilters.DERIVATIVE:
                    filterState.FilterState = [
                        {
                            key: "exchange",
                            value: [this.exchangeValues.NSEF, this.exchangeValues.BSEF],
                        },
                    ];
                    let tempDerivative = filter(ledgerDetails, filterState.FilterState);
                    filterState.FilterState = [
                        {
                            key: "voucherType",
                            value: [
                                this.voucherValues.BILLS,
                                this.voucherValues.JV,
                                this.voucherValues.PAYMENT,
                            ],
                        },
                    ];
                    return filter(tempDerivative, filterState.FilterState);
                case SegmentFilters.CURRENCY:
                    filterState.FilterState = [
                        {
                            key: "exchange",
                            value: [this.exchangeValues.NSEC, this.exchangeValues.BSEC],
                        },
                    ];
                    let tempCrr = filter(ledgerDetails, filterState.FilterState);
                    filterState.FilterState = [
                        {
                            key: "voucherType",
                            value: [
                                this.voucherValues.BILLS,
                                this.voucherValues.JV,
                                this.voucherValues.PAYMENT,
                            ],
                        },
                    ];
                    return filter(tempCrr, filterState.FilterState);
                case SegmentFilters.PAYIN:
                    filterState.FilterState = [
                        { key: "voucherType", value: [this.voucherValues.RECEIPT] },
                    ];
                    return filter(ledgerDetails, filterState.FilterState);
                case SegmentFilters.PAYOUT:
                    filterState.FilterState = [
                        { key: "voucherType", value: [this.voucherValues.PAYMENT] },
                    ];
                    return filter(ledgerDetails, filterState.FilterState);
                default:
                    return ledgerDetails;
            }
        }
        return ledgerDetails;
    }
    detectSelectedFilter(filter, initFilterStateKey) {
        var _a;
        if ((filter === null || filter === void 0 ? void 0 : filter.name) && ((_a = filter === null || filter === void 0 ? void 0 : filter.filters) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let applied = false;
            let filterState = [{ key: initFilterStateKey, value: [] }];
            filter.filters.forEach((filter) => {
                if (filter.selected) {
                    applied = true;
                    filterState[0].value.push(filter.key);
                }
                return filter;
            });
            return {
                FilterApplied: applied,
                FilterState: filterState,
            };
        }
    }
}
